import React from "react";

function ProfileDetail() {
    return (
        <div>ProfileDetail</div>
    )
}
export default ProfileDetail;